<template>
  <v-card flat>
    <v-toolbar flat style="border-bottom:1px  #e3e3e3 solid; ">
      <v-menu>
        <template v-slot:activator="{on,attrs}">
          <v-btn icon v-on="on" v-bind="attrs">
            <v-icon>mdi-information-outline</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold"> ID</v-list-item-title>
                {{ issue.Issue_ID }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold"> Ημ/νια Δημιουργίας</v-list-item-title>
                {{ issue.DateCreated  | fullDate}}
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold"> Αρχική περιγραφή</v-list-item-title>
                {{ issue.IssueTitle }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold"> Τύπος αιτήματος</v-list-item-title>
                {{ issue.IssueTypeDesr }}
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>

      </v-menu>

      <v-toolbar-title style="font-weight: bolder; font-size: 1.1em;"> #{{ issue.Issue_ID }}
      </v-toolbar-title>
      <v-spacer/>
    </v-toolbar>
    <v-list :max-height="isMobile?'79 vh':'74vh'" :min-height="isMobile?'79vh':'74vh'" class="overflow-y-auto"
            v-chat-scroll>
      <v-list-item>
        <v-list-item-action>
          <v-list-item-action-text>
            {{ issue.DateCreated| date }}
          </v-list-item-action-text>
          {{ issue.DateCreated | time }}
        </v-list-item-action>
        <v-list-item-content>
          <strong> Δημιουργήθηκε το Αίτημα: </strong>
          <v-sheet color="primary lighten-5" class="pa-3">
            {{ issue.IssueTitle }}
          </v-sheet>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-for="ii in issue.Items" v-if="ii.ActionNotes">
        <v-list-item-action>
          <v-list-item-action-text>
            {{ ii.DateInsert | date }}
          </v-list-item-action-text>
          {{ ii.DateInsert | time }}
        </v-list-item-action>
        <v-list-item-content>
          <span> {{ ii.Senter }}: </span>
          <v-sheet rounded :color="ii.WhoAnswer_ID === 1? 'primary lighten-5':'grey lighten-4'" class="pa-3">
            {{ ii.ActionNotes }}
          </v-sheet>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-footer>
      <v-card-actions v-if="!issue.Finished">
        <v-dialog v-model="modal" max-width="500">
          <template v-slot:activator="{ on, attrs }">
            <div>
              <v-btn
                  color="primary"
                  dark

                  v-bind="attrs"
                  v-on="on"
                  @click="reply.Action_ID = action.Action_ID"
              >
                ΑΠΑΝΤΗΣΗ
              </v-btn>
              <v-btn
                  @click="reply.Action_ID = -1 "
                  class="ml-3"
                  color="red"
                  dark
                  text
                  v-bind="attrs"
                  v-on="on"
              >
                ΚΛΕΙΣΙΜΟ ΑΙΤΗΜ.
              </v-btn>
            </div>
          </template>
          <v-card>
            <v-form v-model="valid">
              <v-card-title class="headline">
                <span v-if="reply.Action_ID !== -1 ">Απάντηση</span>
                <span v-else> Κλείσιμο Αιτήματος </span>
              </v-card-title>
              <v-card-text>
                <v-alert type="warning" color="orange" outlined v-if="reply.Action_ID === -1">
                  Εάν κλείσετε το αίτημα σας, τότε αυτό θα θεωρηθεί ως ολοκληρωμένο, και θα αφαιρεθεί από την λίστα
                  με τα ανοιχτά θέματα.
                </v-alert>
                <v-combobox
                    v-if="reply.Action_ID !== -1 "
                    :items="activeIssueType.Actions" @change="onActionSelect()"
                    filled
                    item-text="ActionTitle" v-model="action" label="Ενέργεια"
                    :rules="rules.issueActionRule"
                >
                  <template v-slot:item="data">
                    <v-list-item-content>
                      <v-list-item-title> {{ data.item.ActionTitle }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-combobox>
                <v-textarea filled v-model="reply.ActionNotes" label="Μήνυμα"  :rows="5"
                            :rules="rules.ActionNoteRules">

                </v-textarea>

              </v-card-text>
              <v-card-actions >
                <v-spacer></v-spacer>
                <v-btn color="secondary" text @click=cancel()>Άκυρο</v-btn>
                <v-btn color="primary" :disabled="!valid" @click="onReplyIssue()">ΑΠΟΣΤΟΛΗ</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>
      </v-card-actions>
    </v-footer>

  </v-card>
</template>

<script>
import {Issue} from "../../../wl-core/api/classes/Issue";
import {mapActions, mapGetters} from "vuex";
import backButton from "../../../wl-core/mixins/backButton";

export default {
  name: "IssueChat",
  mixins: [backButton(['modal'])],
  props: {
    issue: Issue,

  },
  data: () => ({
    rules: {
      issueActionRule: [
        v => !!v || 'Δεν επιλέξατε τύπο ενέργειας'
      ],
      ActionNoteRules: [
        v => !!v || 'Πρέπει να ωρίσετε ένα μύνημα'
      ]
    },
    valid: true,
    action: null,
    reply: {
      Issue_ID: null,
      Action_ID: null,
      ActionNotes: ''
    },
    modal: false,
    activeIssueType: null,
  }),
  watch: {
    issue: function () {
      {
        this.reply.ActionNotes = "";
        this.reply.Issue_ID = this.issue.Issue_ID;
        this.activeIssueType = this.issueType(this.issue.IssueType_ID);
      }
    }
  },
  created() {
    this.reply.Issue_ID = this.issue.Issue_ID;
    this.getIssueTypes().then(
        () => {
          this.activeIssueType = this.issueType(this.issue.IssueType_ID);
          this.action = this.activeIssueType.Actions[0];
          this.reply.Action_ID = this.activeIssueType.Actions[0].Action_ID

        }
    )
  },
  computed: {
    ...mapGetters([
      "issueType",
      "isMobile"
    ])
  },
  methods: {
    ...mapActions([
      "replyIssue",
      "getIssueTypes",
      "closeIssue"
    ]),
    cancel() {
      this.modal = false;
    },
    onReplyIssue() {
      this.modal = false;
      this.replyIssue(this.reply)
      if(this.reply.Action_ID === -1 ){
        this.$emit('issueClosed');
      }
    },
    onActionSelect() {
      this.reply.Action_ID = this.action.Action_ID
    },
  }
}
</script>

<style scoped>

</style>
